import ActionTypeZona from "../ActionTypeZona";
import {ModosOp} from '../../../../isp._comun/iu/_principal/constantesIuPrin'// import Estado from '../../EstadoDialogoClienteAFacturar'

export default class CargaDeZonaActualizado extends ActionTypeZona {
    ejecutar(estado, nuevoEstado) {

        nuevoEstado.flag.procesandoComandoUpdate = false;
        nuevoEstado.flag.procesandoComando = false;

        for (const property in nuevoEstado.error) {
            nuevoEstado.error[property] = false;
        }

        nuevoEstado.output.domain.resultSet = [...estado.output.domain.resultSet];
        nuevoEstado.output.domain.resultSet[estado.input.domain.indexRowSelected].nombre = estado.input.domain.nombre;
        nuevoEstado.input.domain.rowSelected.nombre = estado.input.domain.nombre;
        // nuevoEstado.flag.sensorMostrarFinalTabla=!estado.flag.sensorMostrarFinalTabla;

        return nuevoEstado;
    }
}
